import React, { useState } from "react";
import { Cloud, Server, Repeat2, Settings2 } from "lucide-react";
import { validSeconds } from "../hooks/useMonitoringTabs";
import { TabNavigation, RotationSettings } from "../styles/CloudStyles";

export default function MonitoringNavigation({ tab, setTab, rotation, setRotation, collapsed, serverCount, cloudCount }) {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [seconds, setSeconds] = useState(String(rotation.seconds));
  const valid = validSeconds(seconds);
  return <>
    <TabNavigation aria-label="Abas de monitoramento">
      {[{ id: "servers", name: "Servidores", Icon: Server, count: serverCount },
        { id: "cloud", name: "Monitoramento cloud", Icon: Cloud, count: cloudCount }].map(({ id, name, Icon, count }) =>
        <button key={id} type="button" aria-label={name} aria-current={tab === id ? "page" : undefined}
          title={name} onClick={() => setTab(id)}>
          <Icon size={17} /><span hidden={collapsed}>{name}</span>{!collapsed && <b>{count}</b>}
        </button>)}
      <button type="button" title="Configurar alternância de abas" aria-label="Configurar alternância de abas"
        aria-expanded={settingsOpen} onClick={() => setSettingsOpen(value => !value)}>
        <Repeat2 size={16} /><span hidden={collapsed}>{rotation.enabled ? (settingsOpen ? "Automático · pausado" : `Alternando · ${rotation.seconds}s`) : "Alternar abas"}</span>
        {!collapsed && <Settings2 size={13} />}
      </button>
    </TabNavigation>
    {settingsOpen && <RotationSettings data-pause-rotation data-rotation-settings>
      <label><input type="checkbox" checked={rotation.enabled}
        onChange={event => setRotation(value => ({ ...value, enabled: event.target.checked }))} /> Alternância automática</label>
      <label>Trocar a cada (segundos)
        <input aria-label="Intervalo de alternância em segundos" type="number" min="5" max="3600" step="1"
          value={seconds} aria-invalid={!valid} onChange={event => {
            const value = event.target.value; setSeconds(value);
            if (validSeconds(value)) setRotation(current => ({ ...current, seconds: Number(value) }));
          }} />
      </label>
      {!valid && <span role="alert">Use um número inteiro de 5 a 3600.</span>}
      <button type="button" onClick={() => setSettingsOpen(false)}>Concluir</button>
    </RotationSettings>}
  </>;
}
